function loadOriginal(url: string, timeout: number = 5000) {
  return new Promise<Event>(function (resolve, reject) {
      var settled = false;
      var script = document.createElement('script');
      var timer = setTimeout(() => finish(new Error(`Timed out loading script: ${url}`)), timeout);
      function finish(error?: unknown, event?: Event) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        script.onload = null;
        script.onerror = null;
        if (error) {
          script.remove();
          reject(error);
        } else {
          resolve(event as Event);
        }
      }
      script.src = url;
      script.onload = (event) => finish(undefined, event);
      script.onerror = (event) => finish(event);
      (document.head || document.body).appendChild(script);
  });
}

function loadRetry(url: string, timeout: number) {
  var addParam = 'retry=' + Math.random();
  var delim = url.indexOf('?') === -1 ? '?' : '&';
  return loadOriginal(url + delim + addParam, timeout);
}

var Loader = {
  memo: {} as Record<string, Promise<Event>>,
  load: function (url: string, timeout: number) {
    if (!Loader.memo[url]) {
      const request = loadOriginal(url, timeout)
        .catch(() => loadRetry(url, timeout));
      const retryable = request.catch((error) => {
        if (Loader.memo[url] === retryable) {
          delete Loader.memo[url];
        }
        throw error;
      });
      Loader.memo[url] = retryable;
    }
    return Loader.memo[url];
  },
};

const win = window as any;

win.__ark_ls = win.__ark_ls || Loader;

export function loadScript(url: string, timeout = 5000) {
  return win.__ark_ls.load(url, timeout);
}
